const userRoutes = [
  {
    path: "/users",
    name: "users",
    component: () => import("@/views/admin/users/AccessControl"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
];
export default userRoutes;
